import * as React from 'react';

import { Loader2, RefreshCw } from 'lucide-react';

import { Button, ButtonProps } from '@/components/ui/button';

export interface ButtonLoadableProps extends ButtonProps {
  isLoading?: boolean;
  showRefreshIcon?: boolean;
  icon?: React.ReactNode;
}

export const ButtonLoadable = React.forwardRef<HTMLButtonElement, ButtonLoadableProps>(
  ({ isLoading, showRefreshIcon, icon, disabled, children, ...props }, ref) => {
    const renderLoadingIcon = () => {
      if (showRefreshIcon) {
        return <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />;
      }
      return isLoading ? <Loader2 className="animate-spin" /> : null;
    };

    return (
      <Button disabled={disabled || isLoading} {...props} ref={ref}>
        {renderLoadingIcon()}
        {icon}
        {children}
      </Button>
    );
  }
);

ButtonLoadable.displayName = 'ButtonLoadable';
